import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Feed from "@/pages/Feed";
import SubmitScenario from "@/pages/SubmitScenario";
import ReportIncident from "@/pages/ReportIncident";
import About from "@/pages/About";
import AboutFramework from "@/pages/AboutFramework";
import Guidelines from "@/pages/Guidelines";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import Bern from "@/pages/Bern";
import BBAPBook from "@/pages/BBAPBook";
import Privacy from "@/pages/Privacy";
import Dashboard from "@/pages/Dashboard";
import AdminIncidents from "@/pages/AdminIncidents";
import AdminScenarioUpload from "@/pages/AdminScenarioUpload";
import AdminSubscribers from "@/pages/AdminSubscribers";
import AdminVolunteers from "@/pages/AdminVolunteers";
import NotFound from "@/pages/NotFound";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-bbap-bg">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/feed" element={<Feed />} />
              <Route path="/submit-scenario" element={<ProtectedRoute><SubmitScenario /></ProtectedRoute>} />
              <Route path="/report-incident" element={<ProtectedRoute><ReportIncident /></ProtectedRoute>} />
              <Route path="/about" element={<About />} />
              <Route path="/framework" element={<AboutFramework />} />
              <Route path="/guidelines" element={<Guidelines />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donate/success" element={<DonateSuccess />} />
              <Route path="/bern" element={<Bern />} />
              <Route path="/bbap-book" element={<BBAPBook />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin/incidents" element={<ProtectedRoute adminOnly><AdminIncidents /></ProtectedRoute>} />
              <Route path="/admin/scenarios" element={<ProtectedRoute adminOnly><AdminScenarioUpload /></ProtectedRoute>} />
              <Route path="/admin/subscribers" element={<ProtectedRoute adminOnly><AdminSubscribers /></ProtectedRoute>} />
              <Route path="/admin/volunteers" element={<ProtectedRoute adminOnly><AdminVolunteers /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
